'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('external.disclosure', {
    views: {
      'externalContent': {
        component: 'disclosure',
      }
    },

    data: {
    }

  });
}



// WEBPACK FOOTER //
// ./client/app/features/disclosure/disclosure.routes.js